export default "__VITE_PUBLIC_ASSET__d644cc3c__"